import React from "react";
import { StyledPagination, FilterButton, Selection } from "./styled";
import { PageRecordProps } from "../../types/PageRecordsProps";

const PageRecords = ({
  records,
  pages,
  selectedValue,
  defaultValue,
  onChangePageSize,
}: PageRecordProps) => {
  return (
    <StyledPagination>
      {records} records in {pages} page(s)
      <FilterButton>
        <Selection
          value={selectedValue ?? defaultValue}
          onChange={onChangePageSize}
        >
          {defaultValue <= 10 ? <option>10</option> : <></>}
          <option>20</option>
          <option>30</option>
          <option>40</option>
          <option>50</option>
        </Selection>
      </FilterButton>
      per page
    </StyledPagination>
  );
};

export default PageRecords;
